<script>
import { mapState, mapActions, mapGetters } from "vuex";
import ClientFactory from "@/api/ClientFactory";
import { VueGoodTable } from 'vue-good-table';
const dropdownsApi = ClientFactory.get("dropdowns");

const emulationApi = ClientFactory.get("emulations");

export default {
  components: {
      VueGoodTable
  },
  data(){
    return {
      emulation_id :null,
      fullname:'',
      employee_id:null,
      emulation_group_id:null,
      total: 0,
      department_id: null,
      year: null,
      currentMonth: null,
      total_point_self_rating: 0,
      approver:null,
      self_note:"",
      department_note:"",
      columns: [
        {
          label: 'STT',
          field: 'rownum',
          thClass: 'text-center width-class',
          tdClass: 'text-center width-class',
        },
        {
          label: 'Tiêu chí/Nội dung',
          field: 'target_name',
          thClass: 'text-center',
          tdClass: 'text-left',
        },
        {
          label: 'Thang điểm (trừ)',
          field: 'point',
          thClass: 'text-center width-point',
          tdClass: 'text-center width-point',
        },
        {
          label: 'Điểm cá nhân tự chấm',
          field: 'self_point',
          //headerField: this.sumCount,
          thClass: 'text-center width-point',
          tdClass: 'text-center width-point',
        },
        {
          label: 'Điểm của Lãnh đạo phòng',
          field: 'department_point',
          headerField: this.sumCount,
          thClass: 'text-center width-point',
          tdClass: 'text-center width-point',
        },
      ],
       data: [
      ],
      data_update: [
      ],
      years: [],
      months: [
        {
          value: 1,
          label: "Tháng 1",
        },
        {
          value: 2,
          label: "Tháng 2",
        },
        {
          value: 3,
          label: "Tháng 3",
        },
        {
          value: 4,
          label: "Tháng 4",
        },
        {
          value: 5,
          label: "Tháng 5",
        },
        {
          value: 6,
          label: "Tháng 6",
        },
        {
          value: 7,
          label: "Tháng 7",
        },
        {
          value: 8,
          label: "Tháng 8",
        },
        {
          value: 9,
          label: "Tháng 9",
        },
        {
          value: 10,
          label: "Tháng 10",
        },
        {
          value: 11,
          label: "Tháng 11",
        },
        {
          value: 12,
          label: "Tháng 12",
        },
      ],
      departments: [],
      state: [true]
    };
  },
  async created() {
    this.approver = this.AppActiveUser.employee_id;
    this.years = await dropdownsApi.get(dropdownsApi.type.YEARS);
    this.departments = await dropdownsApi.get(dropdownsApi.type.DEPARTMENTS);    
    this.getDetail();
  },
  methods: {
    ...mapActions("ui", ['loading', 'closeLoading', 'notify']),
    getDetail: async function () {
      this.emulation_id = this.$route.params.id || -1;
      if(this.emulation_id < 1 || isNaN(this.emulation_id)) {
        return this.$router.push('/emulation/list').catch(() => {})
      }
      this.loading(this.$vs);
      const { data } = await emulationApi.getDetail(this.emulation_id);
      this.closeLoading();
      this.checkResponseData(data);
    },
    selectionChanged(params){
      console.log(params);
    },
    getInfo(row){
      console.log(row);
      if(row.department_point != 0){
        row.department_point = 0;
      }
      else{ 
        row.department_point = Math.abs(row.point);
      }
      // this.data = this.data.map(x => {
      //   let indexChildren = x.children.findIndex(c => c.target_id === row.target_id);
      //   if(indexChildren > -1) {
      //     //Cập nhật row vào data
      //     x.children[indexChildren] = row;
      //     //Cập nhật lại tổng điểm tự chấm theo tiêu đề
      //     x.self_point = this.sumCount(x);
      //     x.children[indexChildren].checked = !x.children[indexChildren].checked;
      //   }
      //   return x;
      // })
      let index = this.data.findIndex(c => c.target_id === row.target_parent_id);
      if(index > -1) {
          const indexChildren = this.data[index].children.findIndex(c => c.target_id === row.target_id);
          if(indexChildren > -1) {
            this.data[index].children[indexChildren].checked = !this.data[index].children[indexChildren].checked;
            this.data[index].children[indexChildren].department_point = row.department_point;
          }
          //Tính tổng gán vào title
          let sum = 0;
          this.data[index].children.forEach(x => {
              sum += x.department_point;
          });
          this.data[index].department_point =sum;
      }
    },
    sumCount: function (rowObj) {
      let sum = 0;
      for (let i = 0; i < rowObj.children.length; i++) {
        sum += rowObj.children[i].department_point;
      }
      return sum;
    },
    checkResponseData(data) {
      console.log(data.data[0]);
      if(data.status == "success")
      {
        if(this.emulation_id < 1 || isNaN(this.emulation_id)) {
          return this.$router.push('/emulation/list').catch(() => {})
        }
        
        this.data_update = data.data[0].title_targets;
        this.data = JSON.parse(JSON.stringify(this.data_update));
        this.emulation_id = data.data[0].emulation_info[0].id;
        this.employee_id = data.data[0].emulation_info[0].employee_id;
        this.emulation_group_id = data.data[0].emulation_info[0].emulation_group_id;
        this.fullname = data.data[0].emulation_info[0].full_name;
        this.department_id = data.data[0].emulation_info[0].department_id;
        this.year = data.data[0].emulation_info[0].year;
        this.currentMonth = data.data[0].emulation_info[0].month;
        this.self_note = data.data[0].emulation_info[0].self_note;
        this.department_note= data.data[0].emulation_info[0].department_note;
      }else{
        // this.notify({
        //   error:true,
        //   title: data.status,
        //   text: data.message
        // });
        return this.$router.push('/emulation/list').catch(() => {});
      }
     },

    rowStyleClassFn(row) {
      return row.is_title > 0 ? 'header-row' : '';
    },
    async saveDepartmentRating(approver_status) {
      this.loading(this.$vs);
      // console.log(JSON.stringify({
      //     id:this.emulation_id,
      //     employee_id:this.employee_id,
      //     emulation_group_id:this.emulation_group_id,
      //     department_id:this.department_id,
      //     year:this.year,
      //     month:this.currentMonth,
      //     self_note:this.self_note,
      //     department_note:this.department_note,
      //     approver_status:"1",
      //     approver:this.approver,
      //     status:1,
      //     targets: this.data
      // }));

      //send to server
      let response = await emulationApi.updateEmulation({
        id:this.emulation_id,
        employee_id:this.employee_id,
        emulation_group_id:this.emulation_group_id,
        department_id:this.department_id,
        year:this.year,
        month:this.currentMonth,
        self_note:this.self_note,
        department_note:this.department_note,
        approver_status:approver_status,
        approver:this.approver,
        status:1,
        type:1, //Phòng ban chấm chấm
        targets: this.data
      });
      this.closeLoading();
      //console.log(response);
      if(response.data.status === 'failed') {
          return this.notify({
              error: true,
              text: response.error || response.data.message,
          })
      }
      if(response.data.status === 'success') {
          this.notify({
              success: true,
              text: response.data.data[0].error_message,
          });
      }
      this.$router.push('/emulation/department');
     },

  },
  computed: {
    ...mapState("auth", ["AppActiveUser"]),
  //   setCheckbox(id) {
  //     if(this.data)

  //   }
   },
  destroyed() {
    this.closeLoading();
  }
};

</script>

<template>
  <div class="department_rating_edit">
    <CCard class= "mb-2">
      <CCardHeader >
          <!-- <h5>CHẤM ĐIỂM THI ĐUA THÁNG</h5> -->
          <span class="card-header-title">Chấm điểm thi đua tháng</span>
      </CCardHeader>
      <CCardBody class="pt-1 pb-2">
        <CRow>
            <CCol sm="3">
              <label class='mb-0'>Họ và tên</label>
              <CInput
                :value.sync="fullname"
                :disabled="true"
                />
            </CCol>
            <CCol sm="3">
              <label class='mb-0'>Phòng ban</label>
              <CSelect
                :options='departments'
                :value.sync="department_id"
                :disabled="true"
              />
            </CCol>
            <CCol sm="2">
              <label class='mb-0'>Năm</label>
              <CSelect
                :options=years
                :value.sync="year"
                :disabled="true"
              />
            </CCol>
            <CCol sm="2">
              <label class='mb-0'>Tháng</label>
              <CSelect
                :options=months
                :value.sync="currentMonth"
                :disabled="true"
              />
            </CCol>
        </CRow>
      </CCardBody>
    </CCard>
    <CCard>
      <vue-good-table
        :columns="columns"
        :rows="data_update" 
        :group-options="{
          enabled: true,
          headerPosition: 'top'
        }"
        :sort-options="{
          enabled:false
        }"
        :row-style-class="rowStyleClassFn"
      >
        <div slot="emptystate">
          Không có dữ liệu
        </div>
        <template
          slot="table-row"
          slot-scope="props"
        >
            <div v-if="props.column.field === 'point'">
                <span v-if="props.row.is_title != 1">-{{props.row.point}}</span>
            </div>
            <div v-else-if="props.column.field === 'department_point'" class="checkbox-left">
                <div v-if="props.row.is_title != 1">
                  <vs-checkbox  v-model="props.row.department_checked" :value="props.row.department_checked" @click="getInfo(props.row)">
                    </vs-checkbox>
                </div>
            </div>
            
        </template>
      </vue-good-table> 
      <CRow>
        <CCol sm="6">
          <CTextarea
            label="Ghi chú cá nhân"
            placeholder="Nhập ghi chú"
            :value.sync="self_note"
            :disabled="true"
            class="p-2"
            />
        </CCol>
        <CCol sm="6">
          <CTextarea
            label="Ghi chú lãnh đạo"
            placeholder="Nhập ghi chú"
            :value.sync="department_note"
            class="p-2"
            />
        </CCol>
      </CRow>
      
      <CCardFooter>
        <CRow>
          <vs-button square class="custom_btn_search"  @click="()=> {this.$router.go(-1)}"><i class='bx bx-left-arrow-alt'></i> &nbsp;Quay lại</vs-button>
          <!-- <vs-button square class="md:mt-2" @click="saveDepartmentRating"><i class='bx bx-save' ></i> &nbsp; Lưu lại</vs-button> -->
          <vs-button color="danger" square class="float-left md:mt-2" @click="saveDepartmentRating(3)"><i class='bx bx-x' ></i> &nbsp;Trả lại</vs-button>
          <vs-button square class="float-left md:mt-2" @click="saveDepartmentRating(1)"><i class='bx bx-save' ></i> &nbsp;Duyệt và gửi Văn phòng</vs-button>
        </CRow>
        
      </CCardFooter>
    </CCard>
  </div>
</template>

<style lang="scss">
  .department_rating_edit{
    .width-class{
      min-width: 3px !important;
    }
    .width-point{
      min-width: 30px !important;
    }
    .header-row {
      background: #f7f8f9;
      color: red;
      font-weight: bold;
    }
    .vs-checkbox-content{
      align-items: center;
      justify-content: center;
    }
    .checkbox-left{
      text-align: left;
    }
  }
</style>